var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04214 1C4.67581 1 2 3.70827 2 7.11544C2 8.77535 2.60421 10.3479 3.81264 11.4836C3.89896 11.571 7.35161 14.7161 7.43793 14.8034C7.78319 15.0655 8.30109 15.0655 8.56004 14.8034C8.64636 14.7161 12.1853 11.571 12.1853 11.4836C13.3938 10.3479 13.998 8.77535 13.998 7.11544C14.0843 3.70827 11.4085 1 8.04214 1ZM8.04214 8.86271C7.09266 8.86271 6.31582 8.07644 6.31582 7.11544C6.31582 6.15445 7.09266 5.36817 8.04214 5.36817C8.99162 5.36817 9.76847 6.15445 9.76847 7.11544C9.76847 8.07644 8.99162 8.86271 8.04214 8.86271Z",
    fill: "#717171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconGray);
export default __webpack_public_path__ + "static/media/location-icon-gray.18eb7cd0ca76846cc8590f2ff9016a3f.svg";
export { ForwardRef as ReactComponent };